import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';
import { Marquee } from '../motion/Marquee';
import { Reveal } from '../motion/Reveal';
import { ENERGY_PROVIDERS } from '../../config/energy-providers';

interface MarqueeLogoItem {
  name: string;
  src?: string;
  alt?: string;
}

interface MarqueeLogosProps {
  title?: string;
  logos?: MarqueeLogoItem[];
}

const DEFAULT_LOGOS: MarqueeLogoItem[] = ENERGY_PROVIDERS.map((p) => ({
  name: p.name,
  src: p.logo,
  alt: p.name,
}));

export function MarqueeLogos({
  title = 'Nous comparons les offres de tous les fournisseurs accessibles à votre profil.',
  logos = DEFAULT_LOGOS,
}: MarqueeLogosProps) {
  return (
    <section className="border-y border-stone-200/60 bg-surface py-12">
      <Container>
        <Reveal>
          <p className="mx-auto max-w-2xl text-center text-sm text-stone-500">{title}</p>
        </Reveal>
      </Container>
      <Reveal className="mt-8">
        <Marquee speed="slow">
          {logos.map((logo) =>
            logo.src ? (
              <img
                key={logo.name}
                src={logo.src}
                alt={logo.alt ?? logo.name}
                loading="lazy"
                decoding="async"
                width={140}
                height={40}
                className="h-9 w-auto max-w-[140px] object-contain opacity-70 grayscale transition duration-350 ease-stripe hover:opacity-100 hover:grayscale-0 md:h-10 md:max-w-[160px]"
              />
            ) : (
              <span
                key={logo.name}
                className="font-display text-2xl font-semibold tracking-tight text-stone-400 transition-colors duration-350 ease-stripe hover:text-ink md:text-3xl"
              >
                {logo.name}
              </span>
            ),
          )}
        </Marquee>
      </Reveal>
    </section>
  );
}

export const MarqueeLogosConfig: ComponentConfig<MarqueeLogosProps> = {
  fields: {
    title: { type: 'textarea' },
    logos: {
      type: 'array',
      arrayFields: {
        name: { type: 'text' },
        src: { type: 'text' },
        alt: { type: 'text' },
      },
      defaultItemProps: { name: '', src: '', alt: '' },
    },
  },
  defaultProps: {
    title: 'Nous comparons les offres de tous les fournisseurs accessibles à votre profil.',
    logos: DEFAULT_LOGOS,
  },
  render: MarqueeLogos,
};
